import * as React from 'react';
import { Button } from '@library/components/buttons';
import { classNames } from '@library/utils';

const CustomCard = (
  {
    className = '',
    ...props
  }: React.HTMLAttributes<HTMLDivElement> & { className?: string },
  ref: React.Ref<HTMLDivElement>
) => (
  <div
    ref={ref}
    className={classNames(
      'bg-soFresh-110 w-full rounded-lg p-4 pt-2',
      className
    )}
    {...props}
  />
);

const CustomCardHeader = (
  {
    className = '',
    children = undefined,
    ...props
  }: React.HTMLAttributes<HTMLDivElement> & {
    className?: string;
    children?: React.ReactNode;
  },
  ref: React.Ref<HTMLDivElement>
) => (
  <div
    ref={ref}
    className={classNames(
      'flex w-full items-center justify-between gap-4 space-y-1 p-3',
      className
    )}
    {...props}
  >
    {
      children
      // TODO - Add expand/collapse button
    }
    <Button className="absolute right-0 top-0" />
  </div>
);

const CustomCardTitle = (
  {
    className = '',
    children = undefined,
    ...props
  }: React.HTMLAttributes<HTMLHeadingElement> & { className?: string },
  ref: React.Ref<HTMLParagraphElement>
) => (
  <h3
    ref={ref}
    className={classNames('text-soClean-100 text-base', className)}
    {...props}
  >
    {children}
  </h3>
);

const CustomCardDescription = (
  {
    className = '',
    ...props
  }: React.HTMLAttributes<HTMLParagraphElement> & { className?: string },
  ref: React.Ref<HTMLParagraphElement>
) => <p ref={ref} className={classNames('text-sm', className)} {...props} />;

const CustomCardContent = (
  {
    className = '',
    ...props
  }: React.HTMLAttributes<HTMLDivElement> & { className?: string },
  ref: React.Ref<HTMLDivElement>
) => <div ref={ref} className={classNames('p-3', className)} {...props} />;

const CustomCardFooter = (
  {
    className = '',
    ...props
  }: React.HTMLAttributes<HTMLDivElement> & { className?: string },
  ref: React.Ref<HTMLDivElement>
) => (
  <div
    ref={ref}
    className={classNames('flex items-center p-6 pt-0', className)}
    {...props}
  />
);

export const Card = React.forwardRef(CustomCard);
export const CardHeader = React.forwardRef(CustomCardHeader);
export const CardFooter = React.forwardRef(CustomCardFooter);
export const CardTitle = React.forwardRef(CustomCardTitle);
export const CardDescription = React.forwardRef(CustomCardDescription);
export const CardContent = React.forwardRef(CustomCardContent);
